export enum UserFormActions {
    Register = 1,
    Edit = 2
}
